import { render, staticRenderFns } from "./InfoButton.vue?vue&type=template&id=0ffb6b28&scoped=true"
import script from "./InfoButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./InfoButton.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ffb6b28",
  null
  
)

export default component.exports